import { render, staticRenderFns } from "./PurchaseOrderApprove.vue?vue&type=template&id=22c311fd&"
import script from "./PurchaseOrderApprove.vue?vue&type=script&lang=js&"
export * from "./PurchaseOrderApprove.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseOrderApprove.vue?vue&type=style&index=0&id=22c311fd&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports